import { render, staticRenderFns } from "./SkeletonLive.vue?vue&type=template&id=0c835514"
import script from "./SkeletonLive.vue?vue&type=script&lang=js"
export * from "./SkeletonLive.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLive.vue?vue&type=style&index=0&id=0c835514&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports